import { useState } from "react";
import Loading from "../../SubDashboard/Loading/Loading";
import InputCustom from "../../UserManagment/SubUserManagment/InputCustom";
import AvatarUpload from "../../Users/SubUsers/AvatarUpload";
import { uploadOrganizationAvatar } from "../../../../Api/Network";
import { Globals } from "../../../../Global";

function EditUser({ user, close, openError, openSuccess }) {

    const [form, setForm] = useState({
        name: user.name || "",
        family: user.family || "",
        userName: user.userName || "",
        mobile: user.mobile || "",
        pass: user.pass || "",
        repPass: user.repPass || "",
    });

    const [preview, setPreview] = useState(user.avatarUrl || null);
    const [avatarFile, setAvatarFile] = useState(null);

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [validationActive, setValidationActive] = useState(false);

    // ---------------- Password Validation ----------------
    const isStrongPassword = (password) => {
        return (
            password.length >= 8 &&
            /[A-Z]/.test(password) &&
            /[a-z]/.test(password) &&
            /[0-9]/.test(password)
        );
    };

    const validateForm = () => {
        const newErrors = {};

        if (!form.userName.trim()) {
            newErrors.userName = "نام کاربری نمی‌تواند خالی باشد";
        }

        if (!form.pass) {
            newErrors.pass = "رمز عبور الزامی است";
        } else if (!isStrongPassword(form.pass)) {
            newErrors.pass =
                "رمز عبور باید حداقل ۸ کاراکتر، شامل حروف بزرگ، کوچک و عدد باشد";
        }

        if (form.pass !== form.repPass) {
            newErrors.repPass = "رمز عبور و تکرار آن یکسان نیستند";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ---------------- Input Change ----------------
    const handleChange = (field) => (value) => {
        setForm(prev => ({ ...prev, [field]: value }));

        if (!validationActive) return;

        if (field === "userName") {
            setErrors(prev => ({
                ...prev,
                userName: value.trim() ? "" : "نام کاربری الزامی است"
            }));
        }

        if (field === "pass") {
            setErrors(prev => ({
                ...prev,
                pass: isStrongPassword(value) ? "" : "رمز عبور ضعیف است"
            }));
        }

        if (field === "repPass") {
            setErrors(prev => ({
                ...prev,
                repPass: value !== form.pass ? "عدم تطابق رمز عبور" : ""
            }));
        }
    };

    // ---------------- Avatar Change ----------------
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setAvatarFile(file);
        setPreview(URL.createObjectURL(file));
    };

    // ---------------- Submit ----------------
    const handleSubmit = async () => {
        setValidationActive(true);

        if (!validateForm()) return;

        setLoading(true);

        try {

            // اگر تصویر جدید انتخاب شده باشد
            if (avatarFile) {
                await uploadOrganizationAvatar(
                    Globals.token,
                    user.id,
                    "https://yahoo.com", // اگر webhook خاصی داری جایگزین کن
                    avatarFile
                );
            }

            // اینجا API ویرایش کاربر قرار می‌گیرد
            // await editUserApiCall(...)

            openSuccess("ویرایش با موفقیت انجام شد");
            handleClose();

        } catch (error) {
            console.error(error);
            openError("خطا در عملیات");
        } finally {
            setLoading(false);
        }
    };

    // ---------------- Close ----------------
    const handleClose = () => {
        setErrors({});
        setValidationActive(false);
        close(false);
    };

    const fields = [
        { title: "نام", field: "name" },
        { title: "نام خانوادگی", field: "family" },
        { title: "نام کاربری", field: "userName" },
        { title: "شماره موبایل", field: "mobile" },
        { title: "رمز عبور", field: "pass" },
        { title: "تکرار رمز عبور", field: "repPass" },
    ];

    return (
        <>
            <div
                className="modal-overlay fixed top-0 left-0 w-screen h-screen bg-black opacity-40"
                onClick={handleClose}
            ></div>

            <div className="fixed top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-primary-100 rounded-lg px-20 py-14">

                <div className="flex justify-between items-center mb-4">
                    <img
                        src="/image/icon/close.png"
                        className="w-5 cursor-pointer"
                        onClick={handleClose}
                    />
                    <p className="text-right text-lg font-bold">ویرایش</p>
                </div>

                {/* Avatar Section */}
                <AvatarUpload
                    preview={preview}
                    onImageChange={handleImageChange}
                />

                {fields.map(f => (
                    <div className="mb-4" key={f.field}>
                        <InputCustom
                            title={f.title}
                            value={form[f.field]}
                            onChange={handleChange(f.field)}
                            error={errors[f.field]}
                        />
                    </div>
                ))}

                <div className="flex justify-between mt-10 gap-4">
                    <button
                        onClick={handleSubmit}
                        className="bg-primary-500 flex-1 rounded-lg text-white p-2"
                    >
                        ویرایش
                    </button>

                    <button
                        onClick={handleClose}
                        className="border border-primary-500 flex-1 rounded-lg text-primary-500 p-2"
                    >
                        لغو
                    </button>
                </div>
            </div>

            {loading && <Loading />}
        </>
    );
}

export default EditUser;





// import { useState } from "react";
// import Loading from "../../SubDashboard/Loading/Loading";
// import InputCustom from "../../UserManagment/SubUserManagment/InputCustom";

// function EditUser({ user, close, openError, openSuccess }) {

//     const [form, setForm] = useState({
//         name: user.name || "",
//         family: user.family || "",
//         userName: user.userName || "",
//         mobile: user.mobile || "",
//         pass: user.pass || "",
//         repPass: user.repPass || "",
//     });

//     const [errors, setErrors] = useState({});
//     const [loading, setLoading] = useState(false);
//     const [validationActive, setValidationActive] = useState(false);

//     const isStrongPassword = (password) => {
//         return (
//             password.length >= 8 &&
//             /[A-Z]/.test(password) &&   // حداقل یک حرف بزرگ
//             /[a-z]/.test(password) &&   // حداقل یک حرف کوچک
//             /[0-9]/.test(password)    // حداقل یک عدد
//         );
//     };

//     const validateForm = () => {
//         const newErrors = {};
//         if (!form.userName.trim()) {
//             newErrors.userName = "نام کاربری نمی‌تواند خالی باشد";
//         }
//         if (!form.pass) {
//             newErrors.pass = "رمز عبور الزامی است";
//         } else if (!isStrongPassword(form.pass)) {
//             newErrors.pass =
//                 "رمز عبور باید حداقل ۸ کاراکتر، شامل حروف بزرگ، کوچک، عدد و کاراکتر خاص باشد";
//         }
//         if (form.pass !== form.repPass) {
//             newErrors.repPass = "رمز عبور و تکرار آن یکسان نیستند";
//         }
//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleChange = (field) => (value) => {
//         setForm(prev => ({ ...prev, [field]: value }));

//         if (!validationActive) return;
//         if (field === "userName") {
//             if (value.trim()) {
//                 setErrors(prev => ({ ...prev, userName: "" }));
//             } else {
//                 setErrors(prev => ({ ...prev, userName: "نام کاربری الزامی است" }));
//             }
//         }
//         if (field === "pass") {
//             setErrors(prev => ({
//                 ...prev,
//                 pass: isStrongPassword(value)
//                     ? ""
//                     : "رمز عبور ضعیف است"
//             }));
//         }
//         if (field === "repPass") {
//             setErrors(prev => ({
//                 ...prev,
//                 repPass: value !== form.pass ? "عدم تطابق رمز عبور" : ""
//             }));
//         }
//     };

//     const handleSubmit = () => {
//         setValidationActive(true);

//         if (!validateForm()) return;

//         setLoading(true);

//         // اینجا API کال میاد
//         setTimeout(() => {
//             setLoading(false);
//             openSuccess();
//             handleClose();
//         }, 1000);
//     };

//     const handleClose = () => {
//         setErrors({});
//         setValidationActive(false);
//         close(false);
//     };


//     const fields = [
//         { title: "نام", field: "name" },
//         { title: "نام خانوادگی", field: "family" },
//         { title: "نام کاربری", field: "userName" },
//         { title: "شماره موبایل", field: "mobile" },
//         { title: "رمز عبور", field: "pass" },
//         { title: "تکرار رمز عبور", field: "repPass" },
//     ];

//     return (
//         <>
//             <div className="modal-overlay fixed top-0 left-0 w-screen h-screen bg-black opacity-40" onClick={handleClose}></div>
//             <div className="fixed top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-primary-100 rounded-lg px-20 py-14 ">
//                 <img src="/image/icon/close.png" className="w-5" onClick={handleClose} />
//                 <p className="text-right text-lg font-bold mb-4">ویرایش</p>

//                 {fields.map(f => (
//                     <div className="mb-4" key={f.field}>
//                         <InputCustom
//                             title={f.title}
//                             value={form[f.field]}
//                             onChange={handleChange(f.field)}
//                             error={errors[f.field]}
//                         />
//                     </div>
//                 ))}

//                 <div className="flex justify-between mt-10">
//                     <button onClick={handleSubmit} className="bg-primary-500 w-44 rounded-lg text-white p-2">ویرایش</button>
//                     <button onClick={handleClose} className="border border-primary-500 w-44 rounded-lg text-primary-500 p-2">لغو</button>
//                 </div>
//             </div>
//             {loading && <Loading />}
//         </>
//     );
// }
// export default EditUser;